


















































































































































































import { Component, Vue } from 'vue-property-decorator'
import { apiMaterialImportTemplate, apiMaterialBatchImport } from '@/api/material'
import configs from '@/config'

@Component
export default class MaterialImport extends Vue {
    activeStep = 0
    fileList: any[] = []
    importResult: any = null
    uploadLoading = false

    // 模板字段说明
    templateFields = [
      { field: '物料编号', name: '物料编号', required: true, format: '必填，唯一标识' },
      { field: '物料条码', name: '物料条码', required: false, format: '选填，唯一标识' },
      { field: '物料名称', name: '物料名称', required: true, format: '必填，物料的名称' },
      { field: '物料别名', name: '物料别名', required: false, format: '选填，物料的别名' },
      { field: '分类ID', name: '分类ID', required: true, format: '必填，物料分类的ID' },
      { field: '品牌', name: '品牌', required: false, format: '选填，物料的品牌' },
      { field: '规格', name: '规格', required: false, format: '选填，物料的规格' },
      { field: '型号', name: '型号', required: false, format: '选填，物料的型号' },
      { field: '单位', name: '单位', required: true, format: '必填，物料的计量单位' },
      { field: '物料类型', name: '物料类型', required: true, format: '必填，1-普通物料，2-批次管理，3-序列号管理' },
      { field: '安全库存', name: '安全库存', required: false, format: '选填，安全库存数量' },
      { field: '最大库存', name: '最大库存', required: false, format: '选填，最大库存数量' },
      { field: '最小库存', name: '最小库存', required: false, format: '选填，最小库存数量' },
      { field: '标准成本', name: '标准成本', required: false, format: '选填，标准成本价格' },
      { field: '最后采购价', name: '最后采购价', required: false, format: '选填，最后采购价格' },
      { field: '平均采购价', name: '平均采购价', required: false, format: '选填，平均采购价格' },
      { field: '零售价', name: '零售价', required: false, format: '选填，零售价格' },
      { field: '会员价', name: '会员价', required: false, format: '选填，会员价格' },
      { field: '推荐供应商名称', name: '推荐供应商名称', required: true, format: '必填，必须是数据库中已存在的供应商名称' },
      { field: '物料状态', name: '物料状态', required: true, format: '必填，1-正常，2-停用，3-淘汰' }
    ]

    // 下载模板
    downloadTemplate () {
      // 调用下载模板接口
      apiMaterialImportTemplate().then((response: any) => {
        if (response.file_url) {
          // 打开下载链接
          window.open(response.file_url, '_blank')
          this.$message.success('模板下载成功')
        } else {
          this.$message.error('模板下载失败：获取文件链接失败')
        }
      }).catch(() => {
        this.$message.error('模板下载失败，请重试')
      })
    }

    // 下一步
    nextStep () {
      if (this.activeStep < 3) {
        this.activeStep++
      }
    }

    // 上一步
    prevStep () {
      if (this.activeStep > 0) {
        this.activeStep--
      }
    }

    // 提交上传
    submitUpload () {
      if (this.fileList.length > 0) {
        this.uploadLoading = true
        const file = this.fileList[0].raw
        if (file) {
          const formData = new FormData()
          formData.append('file', file)
          apiMaterialBatchImport(formData).then((response: any) => {
            this.uploadLoading = false
            this.importResult = {
              success: true,
              success_count: response.success_count || 0,
              error_count: response.error_count || 0,
              error_messages: response.errors || []
            }
            this.activeStep = 3
          }).catch((error: any) => {
            this.uploadLoading = false
            this.importResult = {
              success: false,
              message: '文件上传失败，请重试'
            }
            this.activeStep = 3
          })
        }
      }
    }

    // 上传前验证
    beforeUpload (file: any) {
      const fileName = file.name.toLowerCase()
      const isCSV = fileName.endsWith('.csv')
      const isExcel = fileName.endsWith('.xls') || fileName.endsWith('.xlsx')
      const isAllowed = isCSV || isExcel
      const isLt10M = file.size / 1024 / 1024 < 10

      if (!isAllowed) {
        this.$message.error('只能上传CSV、XLS、XLSX格式的文件！')
        return false
      }
      if (!isLt10M) {
        this.$message.error('文件大小不能超过10MB！')
        return false
      }
      return true
    }

    // 文件变化处理
    handleFileChange (file: any, fileList: any[]) {
      this.fileList = fileList
    }

    // 上传成功
    handleUploadSuccess (response: any) {
      this.uploadLoading = false
      if (response.code === 1) {
        this.importResult = {
          success: true,
          success_count: response.data?.success_count || 0,
          error_count: response.data?.error_count || 0,
          error_messages: response.data?.errors || []
        }
      } else {
        this.importResult = {
          success: false,
          message: response.msg || '导入失败'
        }
      }
      this.activeStep = 3
    }

    // 上传失败
    handleUploadError (error: any) {
      this.uploadLoading = false
      this.importResult = {
        success: false,
        message: '文件上传失败，请重试'
      }
      this.activeStep = 3
    }

    // 重新导入
    resetImport () {
      this.activeStep = 2
      this.fileList = []
      this.importResult = null
    }

    // 返回物料列表
    goToList () {
      this.$router.push('/material/inventory/lists')
    }
}
